// ChangePassword.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "../lib/http"; // fix path: lib (not libs)
import "./AuthForms.css";           // optional: same styling as ForgotPassword

export default function ChangePassword() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ currentPwd: "", newPwd: "", confirm: "" });
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const onChange = (key) => (e) => {
    setForm((f) => ({ ...f, [key]: e.target.value }));
    if (error || message) { setError(""); setMessage(""); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setMessage("");

    if (!form.currentPwd || !form.newPwd || !form.confirm) {
      return setError("Please fill in all fields.");
    }
    if (form.newPwd !== form.confirm) {
      return setError("Passwords do not match");
    }
    if (form.newPwd === form.currentPwd) {
      return setError("New password must be different from current password");
    }

    setLoading(true);
    try {
      const res = await http.fetch("/api/users/me/password", {
        method: "PUT",
        body: JSON.stringify({
          currentPwd: form.currentPwd,
          newPwd: form.newPwd,
        }),
      });

      let data = null;
      try { data = await res.json(); } catch {}

      if (!res.ok) {
        // Prefer API-provided message if present
        const msg = (data && (data.message || data.error)) || "Error updating password";
        throw new Error(msg);
      }

      setMessage("Password updated! Redirecting to dashboard…");
      setTimeout(() => navigate("/dashboard"), 1500);
    } catch (err) {
      setError(err.message || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-form" onSubmit={handleSubmit} noValidate>
        <h1>Change Password</h1>

        {error &&   <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}

        <label>
          Current Password
          <input
            type="password"
            value={form.currentPwd}
            onChange={onChange("currentPwd")}
            autoComplete="current-password"
            required
          />
        </label>

        <label>
          New Password
          <input
            type="password"
            value={form.newPwd}
            onChange={onChange("newPwd")}
            autoComplete="new-password"
            required
          />
        </label>

        <label>
          Confirm New Password
          <input
            type="password"
            value={form.confirm}
            onChange={onChange("confirm")}
            autoComplete="new-password"
            required
          />
        </label>

        <button type="submit" disabled={loading}>
          {loading ? "Saving…" : "Save"}
        </button>
      </form>
    </div>
  );
}
